import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(([number, fractionDigits]) => number.toFixed(fractionDigits));
